module.exports = __webpack_public_path__ + "img/area-texto.65202d1a.svg";